/*
* @Author: gujianghua
* @Date:   2018-08-16 16:35:45
* @Last Modified by:   gujianghua
* @Last Modified time: 2018-08-16 16:53:36
*/
const bigPic = {
	namespaced: true,

	state: {
		picUrl: ''
	},

	getters: {
		picUrl: state => {
			return state.picUrl
		}
	},

	actions: {
		setPic ({ commit }, val) {
			return new Promise((resolve, reject) => {
				commit('set', val)
				resolve()
			}).catch(error => {
				console.log(error)
				reject(error)
			})
		},
		removePic ({ commit }, val) {
			return new Promise((resolve, reject) => {
				commit('remove', val)
				resolve()
			}).catch(error => {
				console.log(error)
				reject(error)
			})
		},
	},

	mutations: {
		set (state, val) {
			state.picUrl = val
		},
		remove (state) {
			state.picUrl = ''
		},
	}
}

export default bigPic


// WEBPACK FOOTER //
// ./src/store/modules/bigPic/index.js